var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.207,
    height: 18.207,
    viewBox: "0 0 18.207 18.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c148e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#932dd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a48d4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle",
    "data-name": "check circle",
    d: "M11.1,2A9.1,9.1,0,1,1,2,11.1,9.1,9.1,0,0,1,11.1,2Zm-.91,13.2,6.372-6.372L15.278,7.542l-5.085,5.085L7.384,9.818,6.1,11.1Z",
    transform: "translate(-2 -2)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.253354c78b46f1b4b3618de8136d17ef.svg";
export { ForwardRef as ReactComponent };